module.exports = __webpack_public_path__ + "img/galleria-original-960.317311f5.webp";